import amplitude from 'amplitude-js';
import { fetchApplicationVersion } from '@/applicationVersionService';

const API_KEY = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY;

let client: null | amplitude.AmplitudeClient = null;

const getClient = () => {
  if (client) {
    return Promise.resolve(client);
  }
  const newClient = amplitude.getInstance();
  newClient.init(API_KEY as string);
  const promise = fetchApplicationVersion().then((version) => {
    newClient.setVersionName(`login-ui-${version}`);
    client = newClient;
    return newClient;
  });
  return promise;
};

export const publishEvent = (
  { component, action }: { component: string; action: string },
  eventProperties: Record<string, unknown>,
  userId?: string
) => {
  if (!API_KEY) return;
  const eventType = `LOGIN_UI:${component}:${action}`;
  getClient().then((client) => {
    if (userId) {
      client.setUserId(userId);
    }
    client.logEvent(eventType, eventProperties);
  });
};
